import React from 'react'
import styled from 'styled-components'
import { GoogleLogin } from '@react-oauth/google'
import { H1 } from '../App'
import { useGoogleAuth } from '../hooks/use-auth'
import { hideOnMobile } from '../constants'

const HeaderDiv = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const HeaderDivCentered = styled(HeaderDiv)`
  justify-content: center;
`

const CenteredImg = styled.img`
  margin: 5em auto;
  display: block;
  ${hideOnMobile}
`

const P = styled.p`
  text-align: center;
  font-size: 1.5em;
`

const Pitalic = styled(P)`
  font-style: italic;
  font-size: 0.9em;
`

const GoogleOverlay = styled.div`
  display: flex;
  justify-content: center;
  margin: 60px auto;
  width: 300px;
  max-width: 100%;
  height: 80px;
  position: relative;
`

const FakeButton = styled.div`
  position: absolute;
  inset: 0;
  background: url('/btn_google_signin_light_normal_web@2x.png') center / contain no-repeat;
  pointer-events: none;
  z-index: 1;
`

const GoogleClickArea = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: 2;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

function LandingPage () {
  const { handleSignInSuccess, handleSignInFailure } = useGoogleAuth()

  return (
    <div>
      <HeaderDivCentered>
        <H1>Your Kindle clippings</H1>
      </HeaderDivCentered>
      <P>Organize the most thought-provoking lines from your Kindle library</P>
      <Pitalic>A pet project by Sam</Pitalic>
      <GoogleOverlay>
        <FakeButton aria-hidden='true' />
        <GoogleClickArea aria-label='Log in with Google'>
          <GoogleLogin
            onSuccess={handleSignInSuccess}
            onError={handleSignInFailure}
            useOneTap={false}
            width='300'
            size='large'
            type='standard'
          />
        </GoogleClickArea>
      </GoogleOverlay>
      <CenteredImg src='/screenshot-main.png' width='1000px' />
    </div>
  )
}

export { LandingPage }
